import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { FunctionEnSavoirPlusModalComponent } from '../../../../../../../../components/ecosystems/function-en-savoir-plus-modal/function-en-savoir-plus-modal.component';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00032 } from '../../../../P00032';
import { P0003607ESPInstallationClComponent } from '../../../EnSavoirPlus/p0003607-espinstallation-cl/p0003607-espinstallation-cl.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import {
  LabelConfigurationComponent,
  LabelConfigurationWarningMode,
} from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { InformationTitleComponent } from '../../../../../../../../components/ecosystems/information-title/information-title.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { P0003607TauxAbaissement } from '../../../Enum/P0003607TauxAbaissement';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P0003607HysteresisValues } from '../../../Enum/P0003607HysteresisValues';
import { P0003605ConsigneRegulationRxEnum } from '../../../../P0003605/Enum/P0003605ConsigneRegulationRx';
import { P0003607TemperatureHivernage } from '../../../Enum/P0003607TemperatureHivernage';
import { getTemperatureType } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p0003607-electrolyseur-parameters',
  templateUrl: './p0003607-electrolyseur-parameters.component.html',
  styleUrls: ['./p0003607-electrolyseur-parameters.component.scss'],
  imports: [
    InformationTitleComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    LabelConfigurationComponent,
    SwitchConfigurationComponent,
  ],
})
export class P0003607ElectrolyseurParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;
  constructor() {
    this.P0003607ESPInstallationClModal =
      this.P0003607ESPInstallationClModal.bind(this);
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
    this.EnSavoirPlusPage = this.EnSavoirPlusPage.bind(this);
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  async P0003607ESPInstallationClModal() {
    const modal = await this.slideModalService.create({
      component: P0003607ESPInstallationClComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P0003607.programmation.ensavoirplus',
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  async EnSavoirPlusPage() {
    const modal = await this.slideModalService.create({
      component: FunctionEnSavoirPlusModalComponent,
      componentProps: {
        description: 'P0003607.reglage.hivernageESP.' + getTemperatureType(),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingsClockScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('esPHorlogeJour'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
        'esPHorlogeJour',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('esPHorlogeSemaine'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
        'esPHorlogeSemaine',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  getProductDeviceTableFromPool() {
    const pool = this.edroNetworkManager.getPoolContext().pool!;
    const master = getPoolMasterClass(pool);
    return master!.getProductDeviceTableFromPool(pool!).firmwareVersion < 6
      ? LabelConfigurationWarningMode.NEED_UPDATE
      : master!.getProductDeviceTableFromPool(pool!).firmwareVersion == 6
        ? LabelConfigurationWarningMode.NEW
        : LabelConfigurationWarningMode.NONE;
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003607TauxAbaissement = P0003607TauxAbaissement;
  protected readonly P0003607HysteresisValues = P0003607HysteresisValues;
  protected readonly P0003605ConsigneRegulationRxEnum =
    P0003605ConsigneRegulationRxEnum;
  protected readonly P0003607TemperatureHivernage =
    P0003607TemperatureHivernage;
}
